import { Conversation } from "@/src/types/Entities/Messaging/Conversation";
import { apiPost } from "./apiClient";
import { Message } from "@/src/types/Entities/Messaging/Message";
import dayjs from "dayjs";

export const caseHasUnreadMessage = (caseId: number, conversations: Array<Conversation>) => {
  const caseConversations = conversations.filter((conversation) => conversation.channel.caseId === caseId);
  return !!caseConversations.find((conversation) => conversationHasUnreadMessage(conversation));
};

export const conversationHasUnreadMessage = (conversation: Conversation) => {
  return !!conversation.containedMessages.find((message) => !message.readByMe);
};

export const formatMessageDate = (date: string): string => {
  const messageDate = dayjs(date);
  const today = dayjs();

  switch (true) {
    case messageDate.isSame(today, "day"):
      return messageDate.format("HH:mm");
    case messageDate.isSame(today.subtract(1, "day"), "day"):
      return "Gestern";
    case messageDate.isSame(today, "year"):
      return messageDate.format("DD. MMM");
    default:
      return messageDate.format("DD.MM.YYYY, HH:mm") + " Uhr";
  }
};

export const markMessagesAsRead = async (messages: Array<Message>) => {
  let promises: Array<Promise<any>> = [];
  messages.forEach((message) => {
    if (!message.readByMe) {
      promises.push(
        apiPost("/message_user_read_statuses", {
          message: "/messages/" + message.id,
        }),
      );
    }
  });
  await Promise.all(promises);
};

export const getNewMessageLink = (productName: string, productId: string | number, conversationId: number | null = null) => {
  const baseLink = `/servicewelt/nachrichten/neu?product=${productName}&productId=${productId}`;
  return conversationId ? `${baseLink}&conversationId=${conversationId}` : baseLink;
};

export const getMessageStep = () => {
  return 0;
};

export const getFinishedStep = (steps: number) => {
  return steps - 1;
};

export const getMainAttachmentStep = () => {
  return 1;
};
